module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.432/js/sprocket_orange.svg"